'use strict'

import {createScapiFetch} from './utils'

/**
 * Submits a contact request by creating a ticket through a specified API endpoint.
 *
 * @param {Object} bodyRequest - The request payload containing the details for the contact request.
 * @param {string} accessToken - The access token used for authenticating the API request.
 * @param {string} siteId - The identifier for the site where the contact request is to be applied.
 * @param {string} locale - The locale identifier for the request, affecting language and regional settings.
 * @returns {Promise<Object>} A promise that resolves to the result of the contact request operation, or an empty object if the request fails.
 */
class ContactUs {
    constructor(config) {
        this.config = config
        this.fetch = createScapiFetch(config)
    }

    /**
     * Asynchronously updates the profile attributes of a user using a specified API endpoint.
     *
     * @param {string} email - The email address of the user whose profile attributes are to be updated.
     * @param {string} accessToken - The access token used for authenticating the API request.
     * @param {string} siteId - The identifier for the site where the profile update is to be applied.
     * @param {string} locale - The locale identifier for the request, affecting language and regional settings.
     * @returns {Promise<Object>} A promise that resolves to the result of the profile update operation, or an empty object if the update fails.
     */
    async submitContactUs(bodyRequest, accessToken, siteId, locale) {
        let urlParam = {
            querystring: {}
        }

        let endpoint = 'createTicket'
        let method = 'POST'
        let args = [urlParam]
        let methodName = 'submitContactUs'
        let requestParams = {
            body: bodyRequest,
            apiPath: 'service-cloud',
            accessToken: accessToken,
            isCached: false,
            siteID: siteId,
            localeID: locale
        }
        let apiVersion = 'v1'

        let contactUsResult = await this.fetch(
            endpoint,
            method,
            args,
            methodName,
            requestParams,
            apiVersion
        )

        return contactUsResult || {}
    }
}

export default ContactUs
